import { render, staticRenderFns } from "./BaseGrid.vue?vue&type=template&id=700aff8f&scoped=true"
import script from "./BaseGrid.vue?vue&type=script&lang=js"
export * from "./BaseGrid.vue?vue&type=script&lang=js"
import style0 from "./BaseGrid.vue?vue&type=style&index=0&id=700aff8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700aff8f",
  null
  
)

export default component.exports